import {useContext} from 'react';
import Button from 'components/Button';
import {c} from 'ttag';
import DateSelectContext from '../../context';

const ButtonClear = () => {
    const {onChangeZonedAtJst, required} = useContext(DateSelectContext);

    if (required) return null;

    const onClick = () => onChangeZonedAtJst(undefined);

    return (
        <Button className="w-full" kind="tertiary" onClick={onClick} size="sm">
            {c('component').t`Clear`}
        </Button>
    );
};

export default ButtonClear;
